<div class="search-container">
  <!-- Search Form -->
  <form (ngSubmit)="onSearch()" class="search-form">
    <mat-form-field appearance="fill" class="search-field">
      <mat-label>Search Properties</mat-label>
      <input
        [(ngModel)]="searchQuery"
        name="search"
        matInput
        placeholder="Enter a keyword"
        required
        />
        <button type="submit" aria-label="Search" mat-icon-button matSuffix>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <!-- Loading Indicator -->
    @if (isLoading) {
      <div class="loading">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    }

    <!-- Grid Container -->
    @if (!isLoading && (properties.length > 0 || searchPerformed)) {
      <div
        class="grid-container"
        >
        <app-grid
          [columns]="columns"
          [data]="properties"
          [filter]="false"
          [readOnly]="true"
          [showContextMenu]="false"
          [showDirty]="false"
          [width]="'100%'"
          [autoHeight]="true"
        ></app-grid>
      </div>
    }

    <!-- No Results Message -->
    @if (!isLoading && properties.length === 0 && searchPerformed) {
      <div
        class="no-results"
        >
        <p>No properties found.</p>
      </div>
    }

    <!-- Paginator -->
    @if (!isLoading && properties.length > 0) {
      <mat-paginator
        (page)="onPageEvent($event)"
        [length]="remoteTotal"
        [pageIndex]="currentPage"
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        showFirstLastButtons="true"
        >
      </mat-paginator>
    }
  </div>
